export default function ProfessionalStreamingInBcnVlc() {
  const meterBars = [{
    height: "40%",
    delay: "0ms",
    duration: "800ms"
  }, {
    height: "70%",
    delay: "150ms",
    duration: "600ms"
  }, {
    height: "100%",
    delay: "300ms",
    duration: "900ms"
  }, {
    height: "85%",
    delay: "100ms",
    duration: "750ms"
  }, {
    height: "50%",
    delay: "450ms",
    duration: "700ms"
  }, {
    height: "90%",
    delay: "200ms",
    duration: "850ms"
  }, {
    height: "30%",
    delay: "600ms",
    duration: "850ms"
  }];
  return <section data-section-id="238890" id="working-with-stars" className="relative flex h-screen w-full flex-col items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/cinematic_stage_performer.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/cinematic_stage_performer.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1671966/img/cinematic_stage_performer.png-wvc-sizes" alt="Professional Stage Performance" loading="lazy" className="h-full w-full object-cover opacity-40 mix-blend-luminosity grayscale" />
        {}
        <div className="absolute inset-0 bg-gradient-to-b from-background/90 via-transparent to-background" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--color-background)_100%)] opacity-90" />
      </div>

      {}
      <div className="pointer-events-none absolute inset-6 z-10 md:inset-12">
        {}
        <div className="absolute left-0 top-0 h-8 w-8 border-l-2 border-t-2 border-primary/30 md:h-16 md:w-16" />
        {}
        <div className="absolute right-0 top-0 h-8 w-8 border-r-2 border-t-2 border-primary/30 md:h-16 md:w-16" />
        {}
        <div className="absolute bottom-0 left-0 h-8 w-8 border-b-2 border-l-2 border-primary/30 md:h-16 md:w-16" />
        {}
        <div className="absolute bottom-0 right-0 h-8 w-8 border-b-2 border-r-2 border-primary/30 md:h-16 md:w-16" />
        
        {}
        <div className="absolute left-1/2 top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 opacity-20">
          <div className="absolute left-1/2 top-0 h-full w-[1px] -translate-x-1/2 bg-primary" />
          <div className="absolute left-0 top-1/2 h-[1px] w-full -translate-y-1/2 bg-primary" />
        </div>
      </div>

      {}
      <div className="relative z-20 flex flex-col items-center px-4 text-center">
        <div className="mb-4 inline-flex items-center gap-2 rounded-md border border-primary/20 bg-primary/5 px-3 py-1 text-xs font-medium uppercase tracking-[0.3em] text-primary backdrop-blur-sm">
          <span className="h-1.5 w-1.5 animate-pulse rounded-md bg-primary" />
          International Experiences
        </div>
        
        <h1 className="font-sans mb-6 text-5xl font-bold uppercase tracking-widest text-foreground sm:text-6xl md:text-8xl lg:text-[7rem] leading-[0.9]">
          The Stage <br />
          Is <br />
          <span className="text-primary drop-shadow-[0_0_25px_rgba(255,215,0,0.4)]">
            Yours
          </span>
        </h1>

        <div className="font-mono flex flex-col gap-2 text-xs uppercase tracking-[0.4em] text-muted-foreground sm:flex-row sm:gap-8 sm:text-sm">
          <span className="flex items-center gap-2">
            <span className="text-primary/60">EST.</span>
            GLOBAL TALENT AGENCY
          </span>
          <span className="hidden text-primary/20 sm:inline">|</span>
          <span className="flex items-center gap-2">
            <span className="text-primary/60">ROLE</span>
            WORKING WITH STARS
          </span>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 z-20 flex -translate-x-1/2 flex-col items-center gap-3">
        <span className="font-mono text-[10px] uppercase tracking-[0.5em] text-primary/50">
          Discover
        </span>
        <div className="flex h-6 items-end gap-[3px]">
          {meterBars.map((bar, i) => <div key={i} data-index={i} className="w-1.5 bg-primary animate-pulse rounded-t-sm" style={{
          height: bar.height,
          animationDelay: bar.delay,
          animationDuration: bar.duration,
          opacity: 0.9 - Math.abs(i - 3) * 0.2
        }} />)}
        </div>
      </div>
    </section>;
}